<template>
<!-- 首页 -->
  <div class="home-box">
    <div class="layout-banner">
      <Nav :activeIndex='"1"'></Nav>
      <el-carousel height="580px" :autoplay="false">
        <el-carousel-item>
          <div class="banner banner3">
                <div class="banner-text w-1200">
                    <div class="big-text animate__animated">助力保险产业上下游实现数字化<br>智能化转型</div>
                    <div class="sm-text animate__animated">数字保险的智能中台及场景保险的智慧经营解决方案供应商</div>
                </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner banner10">
                <div class="banner-text w-1200">
                    <div class="big-text animate__animated">围绕个人及家庭生活场景<br>全面建立风险保障的产品及服务矩阵</div>
                    <div class="sm-text animate__animated">一站式的家庭风险保障解决方案中心</div>
                </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div :class="fix?'all-title fix':'all-title'">
      <ul class="w-1200">
        <li v-for="(item, index) in allMenuList" :key="index" :class="[index===activeMenu?'active':'']" @click="jump(index)">{{item.name}}</li>
      </ul>
    </div>
    <div id="scrollBox" class="applications-content">
        <div class="all-list do-jump">
          <p class="applications-title">产品矩阵</p>
          <p class="subhead">PRODUCT MATRIX</p>
          <div class="product-matrix">
            <el-carousel height="510px" arrow="always" :interval="10000">
            <el-carousel-item v-for="(item,i) in productList" :key="i">
              <div class="w-1200 slide-item">
                <div class="left">
                  <img :src="item.imgURL" alt="">
                </div>
                <div class="right">
                    <div class="title">{{item.title}}</div>
                    <div class="details">{{item.desc}}</div>
                    <div class="carousel-btn" @click="$router.push(item.router)">立即查看</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          </div>
        </div>
        <div class="all-list do-jump">
          <!-- <Particles :particlesId="'particlesNews'"></Particles> -->
          <p class="applications-title">智能中台</p>
          <p class="subhead">INTELLIGENT MIDDLE</p>
          <div class="history-star">
            <div v-for="(item,i) in starList" :key="i">
              <div :class="item.isStar?'history-icon active':'history-icon'">
                <img :src="item.src" alt="">
                <div class="spinner" v-if="item.isStar"></div>
                <!-- <div class="pulse" v-if="item.isStar"></div>
                <div class="pulse-big" v-if="item.isStar"></div> -->
              </div>
              <span class="text">{{item.name}}</span>
              <!-- <el-rate class="mt10" disabled v-model="item.star" :colors="['#FF7F54','#FF7F54','#FF7F54']"></el-rate> -->
            </div>
          </div>
          <div class="history-active-desc animate__animated animate__fadeInUp" v-html="historyList[activeHistory].desc"></div>
          <div class="history-wrapper">
            <div class="history-container">
              <div class="history-line">
                <div class="arrow">
                          <i class="el-icon-arrow-up"></i>
                          <i class="el-icon-arrow-up"></i>
                          <i class="el-icon-arrow-up"></i>
                      </div>
                <div class="history-line-container" :style="`transform: translateX(${transformlenght}px)`">
                  <div :class="[i===activeHistory?'history-line-item history-line-item-active':'history-line-item']" v-for="(item,i) in historyList" :key="i" >
                    <div class="history-line-item-top">
                      <span class="pointer animate__animated"></span>
                      <!-- <div class="arrow" v-if="i===activeHistory">
                          <i class="el-icon-arrow-up"></i>
                          <i class="el-icon-arrow-up"></i>
                          <i class="el-icon-arrow-up"></i>
                      </div> -->
                    </div>
                    <div class="history-line-item-bottom">
                      <div class="history-line-item-bottom-wrapper">
                        <div class="history-line-item-bottom-item"><span>{{item.time}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="all-list do-jump bg-img">
          <p class="applications-title c-white pt80">使命愿景</p>
          <p class="subhead">MISSION VISION</p>
          <Mission></Mission>
        </div>
        <div class="all-list do-jump clearfix fzlc-bg pb60">
          <p class="applications-title">发展历程</p>
          <p class="subhead">DEVELOPMENT HISTORY</p>
          <div class="fzlc-wrapper w-1200">
            <div class="fzlc-container">
                <div v-for="(item,i) in fzlcList" :key="i" class="fzlc-item">
                  <div v-if="i%2 ===0" class="fzlc-item-left">
                    <img :src="item.imgSrc" alt="">
                    <div class="fzlc-text">
                      <span class="fzlc-time">{{item.time}}</span><br>
                      <span class="fzlc-desc">{{item.desc}}</span>
                    </div>
                  </div>
                  <div v-if="i%2 !==0" class="fzlc-item-right">
                    <div class="fzlc-text">
                      <span class="fzlc-time">{{item.time}}</span><br>
                      <span class="fzlc-desc">{{item.desc}}</span>
                    </div>
                    <img :src="item.imgSrc" alt="">
                  </div>
                </div>
            </div>
          </div>
        </div>
        <Partners></Partners>
        <div class="all-list do-jump">
          <p class="applications-title">新闻资讯</p>
          <p class="subhead">NEWS INFORMATION</p>
          <News :type="1"></News>
        </div>
    </div>
    <Footer></Footer>
    <Cornerbar></Cornerbar>
 </div>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Partners from '@/components/Partners'
import Mission from '@/components/Mission'
import News from '@/components/News'
// import Particles from '@/components/Particles'
import Cornerbar from '@/components/Cornerbar'
export default {
  name: 'Home',
  components: {
    Nav,
    Footer,
    Partners,
    Mission,
    News,
    // Particles,
    Cornerbar
  },
  data () {
    return {
      activeMenu: 0,
      fix: false,
      allMenuList: [
        { name: '产品矩阵' },
        { name: '智能中台' },
        { name: '使命愿景' },
        { name: '发展历程' },
        { name: '新闻资讯' }
      ],
      productList: [
        {
          title: '手机风险保障&服务',
          desc:
            '准确定位长期亏损的行业痛点，从智能风控和精细运营出发，结合中保科技围绕行业深度定制的数据中台、AI智能风控、移动智慧分销等全栈技术创新输出覆盖全场景、全流程的完整行业解决方案。',
          imgURL: require('../../assets/web0.png'),
          router: '/phoneSolution'
        },
        {
          title: '宠物风险保障&服务',
          desc:
            '中保科技深耕宠物健康服务领域，自建核心宠物数据库和行业顶尖的宠物医疗专家库，结合鼻纹识别技术、宠物行业医疗大数据、诊疗材料NLP等核心科技，提供宠物风险保障经营的全流程解决方案。全面解决宠物唯一性、赔案真实性、费用合理性等核心痛点，赋能宠物健康服务供应链上下游，实现精细化经营。',
          imgURL: require('../../assets/web1.png'),
          router: '/petSolution'
        },
        {
          title: '家庭风险保障&服务',
          desc:
            '根据家庭风险保障不断丰富的生态布局及快速延伸的居家生活服务需求，区别于传统家庭风险保障的覆盖范围及服务半径，围绕家庭场景构建高质高效的一站式家庭服务解决方案双向赋能渠道，服务链实现全程线上闭环管理',
          imgURL: require('../../assets/web2.png'),
          router: '/householdSolution'
        },
        {
          title: '其他风险保障场景创新',
          desc:
            '对于痛点相似、结构相同但场景各异的创新场景，通过行业数据的挖掘和场景创新需求的解析，基于中保科技构建的模组化智能数据中台，结合移动智慧分销、指南针智慧经营、AI智能理赔系统，均可输出深耕场景、赋能B端及服务C端的技术产品矩阵。',
          imgURL: require('../../assets/web3.png'),
          router: '/otherSolution'
        }
      ],
      activeHistory: 2,
      transformlenght: 0,
      historyList: [
        { time: '2020.01', desc: '保险智能理赔平台上线' },
        {
          time: '2020.05',
          desc:
            '门店智慧零售延保系统2.0上线<br>全面覆盖线下零售场景延保业务需求'
        },
        { time: '2017.12', desc: '碎屏险风控APP 保管家1.0 发布' },
        { time: '2018.01', desc: '第一代产品管理及运营系统发布' },
        { time: '2018.05', desc: '碎屏险风控APP 保管家2.0 迭代' },
        { time: '2018.09', desc: '供应商服务管理小程序正式上线' },
        {
          time: '2018.11',
          desc:
            '第二代全新底层架构、技术栈的中保智能中台迭代发布<br>全维兼容中保业务场景的中台管理及数据运营'
        },
        { time: '2019.03', desc: '碎屏险风控APP 保管家3.0 发布' },
        { time: '2019.08', desc: '门店智慧零售延保系统1.0 上线' },
        { time: '2019.10', desc: '指南针智慧经营数据平台发布' },
        { time: '2020.01', desc: '保险智能理赔平台上线' },
        {
          time: '2020.05',
          desc:
            '门店智慧零售延保系统2.0上线<br>全面覆盖线下零售场景延保业务需求'
        },
        { time: '2017.12', desc: '碎屏险风控APP 保管家1.0 发布' },
        { time: '2018.01', desc: '第一代产品管理及运营系统发布' }
      ],
      fzlcList: [
        {
          time: '2022.06',
          desc: '入驻深圳前海世茂金融中心',
          imgSrc: require('../../assets/fzlc-1.png')
        },
        {
          time: '2021.12',
          desc: '认定为国家高新技术企业',
          imgSrc: require('../../assets/fzlc-7.png')
        },
        {
          time: '2020.07',
          desc: '入选蚂蚁金服旗下蚂上创业营',
          imgSrc: require('../../assets/fzlc-6.png')
        },
        // { time: '2019.08', desc: '获得腾讯产业战略投资', imgSrc: require('../../assets/fzlc-2.png') },
        {
          time: '2019.07',
          desc: '获得A融资，硅谷创投蓝驰',
          imgSrc: require('../../assets/fzlc-3.png')
        },
        {
          time: '2017.11',
          desc: '获得天使轮融资，浩方创投',
          imgSrc: require('../../assets/fzlc-4.png')
        },
        {
          time: '2016.11',
          desc: '中保科技  成立',
          imgSrc: require('../../assets/fzlc-5.png')
        }
      ],
      timer: '',
      starList: [
        {
          name: '智能核保',
          star: 0,
          isStar: false,
          src: require('../../assets/icon/znhb.png')
        },
        {
          name: '智能理赔',
          star: 0,
          isStar: false,
          src: require('../../assets/icon/znlp.png')
        },
        {
          name: '智能销售',
          star: 0,
          isStar: false,
          src: require('../../assets/icon/znxs.png')
        },
        {
          name: '智能风控',
          star: 2,
          isStar: true,
          src: require('../../assets/icon/znfk.png')
        },
        {
          name: '智能数据',
          star: 0,
          isStar: false,
          src: require('../../assets/icon/znsj.png')
        }
      ]
    }
  },
  methods: {
    /**
     * @desc 二级导航栏定位
     */
    jump (index) {
      this.activeMenu = index // 当前导航
      const jump = document.getElementsByClassName('do-jump')[index]
      const height = Number(
        document.getElementsByClassName('all-title')[0].offsetHeight
      ) // 导航的高度
      let scrollTop
      if (this.fix) {
        scrollTop = jump.offsetTop - height // 获取需要滚动的距离
      } else {
        scrollTop = jump.offsetTop - height * 2 // 获取需要滚动的距离
      }
      // Chrome
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth' // 平滑滚动
      })
    },
    /**
     * 智能中台自动播放
     */
    startTimer () {
      this.timer = setInterval(() => {
        var oldleftstr = this.activeHistory
        this.activeHistory = oldleftstr + 1
        this.transformlenght = (oldleftstr - 1) * -220
        this.starList.forEach((item, i) => {
          if (oldleftstr === 2) {
            switch (i) {
              case 0:
                item.star = 0
                item.isStar = false
                break
              case 1:
                item.star = 0
                item.isStar = false
                break
              case 2:
                item.star = 1
                item.isStar = true
                break
              case 3:
                item.star = 2
                item.isStar = false
                break
              case 4:
                item.star = 1
                item.isStar = false
                break
            }
          } else if (oldleftstr === 3) {
            switch (i) {
              case 0:
                item.star = 1
                item.isStar = false
                break
              case 1:
                item.star = 1
                item.isStar = false
                break
              case 2:
                item.star = 1
                item.isStar = false
                break
              case 3:
                item.star = 2
                item.isStar = true
                break
              case 4:
                item.star = 1
                item.isStar = false
                break
            }
          } else if (oldleftstr === 4) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = true
                break
              case 1:
                item.star = 1
                item.isStar = false
                break
              case 2:
                item.star = 2
                item.isStar = false
                break
              case 3:
                item.star = 2
                item.isStar = false
                break
              case 4:
                item.star = 1
                item.isStar = false
                break
            }
          } else if (oldleftstr === 5) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = false
                break
              case 1:
                item.star = 1
                item.isStar = false
                break
              case 2:
                item.star = 2
                item.isStar = false
                break
              case 3:
                item.star = 2
                item.isStar = false
                break
              case 4:
                item.star = 2
                item.isStar = true
                break
            }
          } else if (oldleftstr === 6) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = false
                break
              case 1:
                item.star = 1
                item.isStar = false
                break
              case 2:
                item.star = 3
                item.isStar = false
                break
              case 3:
                item.star = 3
                item.isStar = true
                break
              case 4:
                item.star = 2
                item.isStar = false
                break
            }
          } else if (oldleftstr === 7) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = false
                break
              case 1:
                item.star = 1
                item.isStar = false
                break
              case 2:
                item.star = 3
                item.isStar = true
                break
              case 3:
                item.star = 3
                item.isStar = false
                break
              case 4:
                item.star = 2
                item.isStar = false
                break
            }
          } else if (oldleftstr === 8) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = false
                break
              case 1:
                item.star = 1
                item.isStar = false
                break
              case 2:
                item.star = 3
                item.isStar = false
                break
              case 3:
                item.star = 3
                item.isStar = false
                break
              case 4:
                item.star = 3
                item.isStar = true
                break
            }
          } else if (oldleftstr === 9) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = false
                break
              case 1:
                item.star = 2
                item.isStar = true
                break
              case 2:
                item.star = 3
                item.isStar = false
                break
              case 3:
                item.star = 3
                item.isStar = false
                break
              case 4:
                item.star = 3
                item.isStar = false
                break
            }
          } else if (oldleftstr === 10) {
            switch (i) {
              case 0:
                item.star = 2
                item.isStar = false
                break
              case 1:
                item.star = 2
                item.isStar = false
                break
              case 2:
                item.star = 3
                item.isStar = true
                break
              case 3:
                item.star = 3
                item.isStar = false
                break
              case 4:
                item.star = 3
                item.isStar = false
                break
            }
          } else if (oldleftstr === 11) {
            switch (i) {
              case 0:
                item.star = 0
                item.isStar = false
                break
              case 1:
                item.star = 0
                item.isStar = false
                break
              case 2:
                item.star = 0
                item.isStar = false
                break
              case 3:
                item.star = 2
                item.isStar = true
                break
              case 4:
                item.star = 0
                item.isStar = false
                break
            }
          }
        })
        if (oldleftstr > 10) {
          this.activeHistory = 2
          this.transformlenght = 0
        }
      }, 4000)
    },
    clearTimer () {
      clearInterval(this.timer)
    }
  },
  mounted () {
    this.startTimer()
    // 监听dom元素的scroll事件
    window.addEventListener(
      'scroll',
      () => {
        if (document.getElementById('scrollBox')) {
          const height =
            document.getElementById('scrollBox').offsetTop -
            Number(
              document.getElementsByClassName('all-title')[0].offsetHeight
            )
          if (window.scrollY > height) {
            this.fix = true
          } else {
            this.fix = false
          }
        }
      },
      true
    )
  },
  created () {},
  destroyed () {
    window.removeEventListener('scroll', () => {}, false)
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.home-box {
  .layout-banner {
    position: relative;
    height: 580px;
    .el-carousel__item.is-active {
      .banner-text {
        // animation-duration: 1.5s;
        // animation-name: zoomIn;
        .big-text {
          animation-duration: 1.8s;
          animation-name: slideInRight;
        }
        .sm-text {
          animation-duration: 1.8s;
          animation-name: slideInRight;
        }
      }
    }
  }
  .banner {
    // background: url(../../assets/banner8.png) 100% no-repeat;
    // transition: all 7.6s cubic-bezier(0.04, 0.79, 1, 1) !important;
    // transform: scale(1.02);
    position: absolute;
    top: 0;
    width: 100%;
    height: 580px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: #0b0f1a;
    &.banner1 {
      background-image: url(../../assets/banner1.png);
    }
    &.banner2 {
      background-image: url(../../assets/banner2.png);
    }
    &.banner3 {
      background-image: url(../../assets/banner3.png);
    }
    &.banner4 {
      background-image: url(../../assets/banner4.png);
    }
    &.banner5 {
      background-image: url(../../assets/banner5.png);
    }
    &.banner6 {
      background-image: url(../../assets/banner6.png);
    }
    &.banner7 {
      background-image: url(../../assets/banner7.png);
    }
    &.banner8 {
      background-image: url(../../assets/banner8.png);
    }
    &.banner9 {
      background-image: url(../../assets/banner9.png);
    }
    &.banner10 {
      background-image: url(../../assets/banner10.png);
    }
    .banner-text {
      font-family: "SourceHanSansCN-Regular";
      margin: 0 auto;
      padding-top: 189px;
      .big-text {
        color: #fff;
        font-size: 36px;
        line-height: 60px;
        letter-spacing: 1px;
        font-weight: bold;
        animation-name: none;
      }
      .sm-text {
        margin-top: 27px;
        line-height: 32px;
        font-size: 18px;
        letter-spacing: 1px;
        color: #e5e5e5;
        font-weight: 400;
        animation-name: none;
      }
    }
  }
  .all-title {
    box-shadow: 10px 10px 13px -16px #888;
    height: 67px;
    background: #fff;
    width: 100%;
    &.fix {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }
    ul {
      margin: 0 auto;
      text-align: center;
      li {
        color: #666;
        padding: 17px 0;
        margin: 0 40px;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
        &.active {
          border-bottom: 2px solid #007dff;
          color: #333;
        }
      }
    }
  }
  .all-list {
    position: relative;
    &.bg-img {
      height: 650px;
      background: url(../../assets/background_1.png) 50% no-repeat;
    }
    &.fzlc-bg {
      // height: 700px;
      background: url(../../assets/ab_01.jpg) 100% no-repeat;
      background-position: center center;
      // margin-bottom: 60px;
    }
    .applications-title {
      display: block;
      text-align: center;
      font-weight: 700;
      // padding: 60px 0 30px 0;
      padding-top: 60px;
      font-size: 28px;
      line-height: 30px;
      color: #333;
      // &:hover{
      //     &::after{
      //         width: 120px;
      //     }
      // }
      // &::after{
      //     content: '';
      //     display: block;
      //     width: 45px;
      //     height: 4px;
      //     background: #007dff;
      //     margin: 27px auto 0;
      //     transition: all 0.3s;
      // }
    }
    .subhead {
      font-size: 14px;
      color: #ccc;
      line-height: 24px;
      text-transform: uppercase;
      margin-top: 5px;
      padding-bottom: 30px;
      text-align: center;
      letter-spacing: 1px;
    }
    .product-matrix {
      margin: 0 auto;
      background-color: #fafafa;
      .slide-item {
        margin: 0 auto;
        .left {
          margin: 75px 60px 52px 0;
          width: 654px;
          display: inline-block;
          img {
            width: 100%;
          }
        }
        .right {
          display: inline-block;
          margin-top: 120px;
          text-align: left;
          vertical-align: top;
          .title {
            line-height: 35px;
            height: 35px;
            font-size: 22px;
            font-weight: 700;
            color: #444;
            opacity: 1;
          }
          .details {
            width: 416px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            color: #999;
            opacity: 0.85;
            margin-bottom: 48px;
            margin-top: 25px;
          }
          .carousel-btn {
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 34px;
            width: 100px;
            height: 34px;
            background: linear-gradient(
              135deg,
              #2c7cff 0%,
              rgba(70, 160, 255, 0.9) 100%
            );
            border-radius: 3px;
            text-align: center;
            border: 1px solid transparent;
            cursor: pointer;
            &:hover {
              border: 1px solid #2c7cff;
              color: #2c7cff;
              background: transparent;
            }
          }
        }
      }
    }
    .history-wrapper {
      position: relative;
      &::before {
        position: absolute;
        content: "";
        top: 50%;
        left: 0;
        // transform: translateY(-20px);
        width: 100%;
        height: 1px;
        background: #dfe6ee;
        // border-bottom: 1px dashed #dfe6ee;
      }
      .history-container {
        position: relative;
        width: 1100px;
        margin: 0 auto;
        // background: #fff;
        // &::before{
        //   position: absolute;
        //   content: "";
        //   top: 50%;
        //   left: 0;
        //   transform: translateY(-20px);
        //   width: 100%;
        //   height: 1px;
        //   background: #dfe6ee;
        // }
        .history-line {
          margin: 0 auto;
          width: 1100px;
          box-sizing: content-box;
          overflow: hidden;
          position: relative;
          .arrow {
            position: absolute;
            top: 10%;
            left: 50%;
            transform: translate(-50%, 0%);
            i {
              font-size: 18px;
              display: block;
              text-align: center;
              color: #007dff;
              font-weight: bold;
              animation: arrow-movement 2s ease-in-out 0.6s infinite;
              &:first-child {
                animation: arrow-movement 2s ease-in-out 0.7s infinite;
              }
              &:last-child {
                animation: arrow-movement 2s ease-in-out 0.4s infinite;
              }
            }
          }
          .history-line-container {
            width: 3080px;
            transition: all 0.4s ease-in-out 0s;
            .history-line-item {
              float: left;
              width: 220px;
              height: 240px;
              .history-line-item-top {
                position: relative;
                height: 50%;
                .pointer {
                  width: 30px;
                  height: 30px;
                  position: absolute;
                  left: 50%;
                  bottom: -15px;
                  margin-left: -15px;
                  animation-name: none;
                  &::before {
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    bottom: 50%;
                    left: 50%;
                    transform: translate(-50%, 50%);
                    content: "";
                    border-radius: 50%;
                    background-color: #fff;
                    border: 1px solid #ccc;
                    z-index: 2;
                  }
                  &::after {
                    width: 8px;
                    height: 8px;
                    background-color: #ccc;
                    position: absolute;
                    bottom: 50%;
                    left: 50%;
                    transform: translate(-50%, 50%);
                    content: "";
                    border-radius: 50%;
                    z-index: 3;
                  }
                }
              }
              .history-line-item-bottom {
                height: 50%;
                padding: 0 40px;
                font-size: 16px;
                color: #333;
                line-height: 26px;
                text-align: center;
                padding-top: 24px;
              }
              &.history-line-item-active {
                .history-line-item-top {
                  font-size: 16px;
                  color: #16181e;
                  // &::before{
                  //   content: '';
                  //   width: 2px;
                  //   height: 100px;
                  //   display: block;
                  //   bottom: 13px;
                  //   left: 50%;
                  //   margin-left: -1px;
                  //   background-image: linear-gradient(0deg,rgba(106,202,255,0.40) 43%,rgba(106,202,255,0.00) 100%);
                  //   position: absolute;
                  // }
                  // &::after{
                  //   content: '';
                  //   display: block;
                  //   position: absolute;
                  //   height: 10px;
                  //   width: 2px;
                  //   background-image: linear-gradient(0deg,rgba(106,202,255,0.00) 0%,#6ACAFF 50%,rgba(106,202,255,0.00) 100%);
                  //   bottom: 13px;
                  //   left: 50%;
                  //   margin-left: -1px;
                  //   animation: sout 2s linear infinite;
                  // }
                  .pointer {
                    animation-duration: 0.7s;
                    animation-name: pulse;
                    animation-iteration-count: infinite;
                    &::before {
                      width: 26px;
                      height: 26px;
                      position: absolute;
                      bottom: 50%;
                      left: 50%;
                      transform: translate(-50%, 50%);
                      content: "";
                      border-radius: 50%;
                      border: 1px solid transparent;
                      background-color: rgba(78, 142, 252, 0.5);
                      z-index: 2;
                    }
                    &::after {
                      width: 13px;
                      height: 13px;
                      background-color: rgba(78, 142, 252, 0.8);
                      position: absolute;
                      bottom: 50%;
                      left: 50%;
                      transform: translate(-50%, 50%);
                      content: "";
                      border-radius: 50%;
                      z-index: 3;
                    }
                  }
                }
                .history-line-item-bottom-item {
                  font-size: 18px;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
    .history-active-desc {
      text-align: center;
      width: 1100px;
      margin: 0 auto;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 20px;
      margin-top: 60px;
      font-size: 16px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      animation-duration: 4s;
      animation-iteration-count: infinite;
      // animation: fadeInUp 5s ease-in-out 5s infinite;
    }
    .history-star {
      width: 900px;
      margin: 10px auto;
      display: flex;
      justify-content: space-around;
      text-align: center;
      .text {
        font-weight: 500;
        color: #333;
        font-size: 16px;
        // font-family: "PingFangSC-Medium";
      }
      .history-icon {
        position: relative;
        width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: #f5f5f5;
        margin-bottom: 15px;
        img {
          height: 30px;
        }
        //旋转
        .spinner {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          position: absolute;
          border: 4px solid transparent;
          border-top-color: #007dff;
          border-bottom-color: #007dff;
          animation: spin 2s linear infinite;
        }
        &.active {
          img {
            animation: shrink 2s ease infinite;
          }
        }
        // 水波纹
        .pulse {
          position: absolute;
          top: -35px;
          left: -28px;
          width: 120px;
          height: 120px;
          border: 2px solid rgba(78, 142, 252, 0.8);
          border-radius: 50%;
          z-index: 100;
          opacity: 0;
          background: rgba(78, 142, 252, 0.6) !important;
          animation: warn 0.9s ease-out;
          animation-iteration-count: infinite;
          box-shadow: 1px 1px 30px rgba(78, 142, 252, 1);
        }
        .pulse-big {
          position: absolute;
          top: -35px;
          left: -28px;
          width: 120px;
          height: 120px;
          border: 2px solid rgba(78, 142, 252, 0.8);
          border-radius: 50%;
          z-index: 100;
          opacity: 0;
          background: rgba(78, 142, 252, 0.6) !important;
          animation: warn1 0.9s ease-out;
          animation-iteration-count: infinite;
          box-shadow: 1px 1px 30px rgba(78, 142, 252, 1);
        }
      }
    }
    .fzlc-wrapper {
      // height: 485px;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        top: 0;
        left: 50%;
        transform: translateX(-1px);
        width: 1px;
        height: 100%;
        background: #dfe6ee;
      }
      .fzlc-container {
        width: 780px;
        margin: 0 auto;
        .fzlc-item {
          position: relative;
          width: 100%;
          height: 90px;
          cursor: pointer;
          transition: box-shadow 0.3s, border 0.3s, background-color 0.3s,
            color 0.3s, transform 0.3s;
          img {
            height: 88px;
            transition: box-shadow 0.3s, border 0.3s, background-color 0.3s,
              color 0.3s, transform 0.3s;
          }
          .fzlc-text {
            display: inline-block;
            height: 100%;
            vertical-align: top;
            padding-top: 15px;
            width: 240px;
            transition: box-shadow 0.3s, border 0.3s, background-color 0.3s,
              color 0.3s, transform 0.3s;
            .fzlc-time {
              font-size: 21px;
              font-weight: 500;
              color: #333;
              line-height: 29px;
            }
            .fzlc-desc {
              font-size: 14px;
              font-weight: 500;
              color: #999;
              line-height: 20px;
            }
          }
          .fzlc-item-left {
            text-align: right;
            padding-right: 50px;
            width: 50%;
            float: left;
          }
          .fzlc-item-right {
            padding-left: 50px;
            width: 50%;
            float: right;
          }
          &::before {
            width: 12px;
            height: 12px;
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 50%);
            content: "";
            border-radius: 50%;
            background-color: #fff;
            border: 1px solid #007dff;
            transition: box-shadow 0.3s, border 0.3s, background-color 0.3s,
              color 0.3s, transform 0.3s;
          }
          &::after {
            width: 8px;
            height: 8px;
            background-color: #007dff;
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 50%);
            content: "";
            border-radius: 50%;
            transition: box-shadow 0.3s, border 0.3s, background-color 0.3s,
              color 0.3s, transform 0.3s;
          }
          &:hover {
            .fzlc-text {
              .fzlc-time {
                font-weight: bold;
              }
              .fzlc-desc {
                font-weight: bold;
              }
              // transform: scale(1.5);
              // transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
            }
            // img{
            //   transform: scale(1.5);
            //   transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
            // }
            transform: scale(1.2);
            // transform: translateY(-3px);
            // box-shadow: 0px 3px 12px rgba(102, 102, 102, 0.16);
            transition: box-shadow 0.3s, border 0.3s, background-color 0.3s,
              color 0.3s, transform 0.3s;
          }
        }
      }
    }
  }
}
</style>
